export const agentsList = [
  {
    id: 1,
    location: "Харків, Харківська область",
    name: "Компанія Ortho Max",
    tel: "+38 067 632 49 52",
  },
  {
    id: 2,
    location: "Київ, Київська область",
    name: "Компанія Ortho Riches",
    tel: "+38 099 414 44 58",
  },
  {
    id: 3,
    location: "Західноукраїнський регіон",
    name: "Компанія Gaisan dental group",
    tel: "+38 099 763 72 52",
  },
  {
    id: 4,
    location: "Усі області України",
    tel: "+38 066 977 23 38",
  },
];
